import { apiGet, apiPost } from './client';
import type {
  InternalQAQueueResponse,
  InternalQADetailsResponse,
  ApprovalResponse,
  RevisionResponse,
} from '../types/api';

// Re-export types for consumers
export type {
  InternalQAQueueResponse,
  InternalQADetailsResponse,
  ApprovalResponse,
  RevisionResponse,
};

export async function getQAQueue(): Promise<InternalQAQueueResponse> {
  return apiGet<InternalQAQueueResponse>('/api/internal-qa/queue');
}

export async function getSiteDetails(
  websiteId: string
): Promise<InternalQADetailsResponse> {
  return apiGet<InternalQADetailsResponse>(`/api/internal-qa/${websiteId}`);
}

export async function approveSite(
  websiteId: string,
  reviewer?: string
): Promise<ApprovalResponse> {
  return apiPost<ApprovalResponse>(`/api/internal-qa/${websiteId}/approve`, {
    reviewer,
  });
}

export interface RevisionRequestData {
  page?: string;
  section?: string;
  description: string;
  reviewer?: string;
}

export async function requestRevision(
  websiteId: string,
  data: RevisionRequestData
): Promise<RevisionResponse> {
  return apiPost<RevisionResponse>(
    `/api/internal-qa/${websiteId}/request-revision`,
    data
  );
}

export interface ImpersonateCustomerResponse {
  success: boolean;
  portalUrl: string;
  customer: {
    id: string;
    email: string;
    businessName: string | null;
    websiteId: string | null;
    websiteStatus: string | null;
    websiteUrl: string | null;
    customDomain: string | null;
  };
  expiresAt: string;
}

export async function impersonateCustomer(
  customerId: string
): Promise<ImpersonateCustomerResponse> {
  return apiPost<ImpersonateCustomerResponse>(
    '/api/admin/impersonate-customer',
    { customerId }
  );
}

export interface MarkLiveResponse {
  success: boolean;
  message: string;
  liveUrl?: string;
}

export interface MarkLiveOptions {
  /** Admin "Launch Now" override: launch without waiting for customer approval. */
  override?: boolean;
  markedBy?: string;
}

export async function markSiteLive(
  websiteId: string,
  options?: MarkLiveOptions
): Promise<MarkLiveResponse> {
  return apiPost<MarkLiveResponse>(`/api/site/${websiteId}/mark-live`, options);
}
